/* eslint-disable local-rules/on-click-analytics-id */
import React, { useState, useEffect, useMemo } from 'react';
import { getDocumentList } from './sample-documents-list';
import * as sc from './sample-documents.styles';

const SampleDocuments = ({ step, substep, handleClose }) => {
  const [imageSources, setImageSources] = useState([]);
  const [currentImage, setCurrentImage] = useState(0);

  const { subText, documents } = useMemo(() => getDocumentList(step, substep), [
    step,
    substep
  ]);

  const isPrevNavActive = currentImage > 0;
  const isNextNavActive = currentImage < documents.length - 1;

  useEffect(() => {
    const images = documents.map(documentName => {
      const image = new Image();
      image.src = `${process.env.ASSETS_CDN_URL}/doc-upload-samples/${documentName}`;
      image.alt = documentName;
      return image;
    });

    setImageSources(images);
  }, [documents]);

  const nextImage = () => {
    if (currentImage < documents.length - 1) {
      setCurrentImage((currentImage + 1) % documents.length);
    }
  };

  const prevImage = () => {
    if (currentImage > 0) {
      setCurrentImage((currentImage - 1 + documents.length) % documents.length);
    }
  };

  return (
    <sc.Container>
      <sc.CloseButton onClick={handleClose}>X</sc.CloseButton>
      <sc.Content>
        <sc.Image
          src={imageSources[currentImage]?.src || null}
          alt={imageSources[currentImage]?.alt || null}
        />
        <sc.SubText>{subText}</sc.SubText>
        <sc.Navigation>
          <sc.NavigationButtonContainer
            onClick={prevImage}
            active={currentImage > 0}
          >
            {isPrevNavActive ? (
              <sc.NavigationPrevEnabled />
            ) : (
              <sc.NavigationPrevDisabled />
            )}
          </sc.NavigationButtonContainer>
          <sc.ImageIndex>
            {currentImage + 1}/{documents.length}
          </sc.ImageIndex>
          <sc.NavigationButtonContainer
            onClick={nextImage}
            active={currentImage < documents.length - 1}
          >
            {isNextNavActive ? (
              <sc.NavigationNextEnabled />
            ) : (
              <sc.NavigationNextDisabled />
            )}
          </sc.NavigationButtonContainer>
        </sc.Navigation>
      </sc.Content>
    </sc.Container>
  );
};

export default SampleDocuments;
